import { TBL_PART_LOADING_INSTRUCTION } from './apiEndPoints';
import { createCRUDHook } from './createCRUDHook';
import { PartLoadingInstructionDto } from 'utils/models';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartLoadingInstructionDto>({
    entityName: 'PartLoadingInstruction',
    endpoint: TBL_PART_LOADING_INSTRUCTION,
  });

export const PartLoadingInstructionContext = Context;
export const usePartLoadingInstructionManager = useManager;
export const usePartLoadingInstruction = useConsumer;
